import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { LangContext } from "../LangContext.jsx";
class AuthDoc2Sign extends Component {
    static contextType = LangContext;
    constructor() {
        super();

        this.state = {
            doc2signCredentials: null,
        };

        this.checkboxRef = React.createRef(false);
    }

    async componentDidMount() { 
        this.getDoc2SignCredentials();
        console.log('componentDidMount')
        this.storeDoc2SignCredentials();
    }

    /**
     * Store the Doc2Sign credentials if the code is present in the URL.
     */
    async storeDoc2SignCredentials() {
        const urlParams = new URLSearchParams(window.location.search);
        const code = urlParams.get('code');

        if (! code) return;

        window.blockUI();

        const response = await axios.post('/api/doc2sign-credentials', {
            code: code,
            enabled: true,
        })
        .then((response) => {
            if (response.status != '201') return;

            this.checkboxRef.current.checked = response.data.data.enabled;

            this.setState({
                doc2signCredentials: response.data.data,
            });

            urlParams.delete('code');

            const urlWithoutCode = `${window.location.pathname}?${urlParams.toString()}`;

            if (window.history && window.history.replaceState) {
                window.history.replaceState({}, document.title, urlWithoutCode);
            }
        }).catch(() => {
            swal.fire({
                title: 'RFC no coincide',
                text: 'El RFC con el cual estas accesando a Exppedify deberá coincidir con el RFC de la cuenta registrada en Doc2sign. Favor de verificar',
                icon: 'warning',
                width: 650,
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
                customClass: {
                    confirmButton: 'btn font-weight-bold btn-light-primary',
                }
            })
        });

        window.unblockUI();
    };

    /**
     * Get all the additional Doc2Sign dossier documents.
     */
    async getDoc2SignCredentials() {
        console.log('getDoc2SignCredentials')
        const response = await axios.get('/api/doc2sign-credentials');
        console.log(response)
        if (response.data.length <= 0) return;

        this.checkboxRef.current.checked = response.data.data.enabled;

        this.setState({
            doc2signCredentials: response.data.data,
        });
    }

    /**
     * Redirect to Doc2Sign auth widget.
     */
    async redirectToDoc2SignAuthWidget() {
        if (this.state.doc2signCredentials) {
            return;
        }

        window.blockUI();

        const response = await axios.get('/api/login-doc2sign-widget')
            .catch(() => window.unblockUI());

        const widgetUrl = response.data.data.url;

        window.location.replace(widgetUrl);
    }

    /**
     * Toggle the Doc2Sign feature.
     *
     * @param   {object} e
     */
    toggleDoc2SignFeature(e) {
        console.log(this.state.doc2signCredentials)
        if (!this.state.doc2signCredentials) return;

        const enabled = e.target.checked;

        axios.patch(`/api/doc2sign-credentials/${this.state.doc2signCredentials.id}`, {
            'enabled': enabled,
        })
        .then(() => this.checkboxRef.current.checked = enabled)
        .catch(() => this.checkboxRef.current.checked = !enabled);
    }

    async logoutDoc2Sign() {
        window.blockUI();

        await axios.delete(`/api/doc2sign-credentials/${this.state.doc2signCredentials.id}`)
            .then(() => {
                this.checkboxRef.current.checked = false;
                this.setState({ doc2signCredentials: null })
            });

        window.unblockUI()
    }

    render() {
        const { lang } = this.context; 
        const isLoggedIn = this.state.doc2signCredentials;

        return (
            <div className="card card-custom gutter-b h-100" style={{ border: '1px solid #E4E6EF', borderRadius: 14, boxShadow: 'none' }}>
                <div className="card-body p-7">
                    <div className="d-flex align-items-center justify-content-between mb-6">
                        <span className="font-weight-bolder font-size-lg text-dark">Doc2sign</span>

                        <span className="badge" style={{ background: isLoggedIn ? '#ECFDF5' : '#F3F4F6', borderRadius: 9999, padding: '8px 16px' }}>
                            <span
                                className="d-inline-block mr-2"
                                style={{ width: 10, height: 10, borderRadius: 9999, background: isLoggedIn ? '#10B981' : '#D1D5DB', verticalAlign: 'middle' }}
                            ></span>
                            <span className="font-weight-bold" style={{ color: isLoggedIn ? '#059669' : '#9CA3AF' }}>
                                {isLoggedIn ? 'Conectado' : 'No conectado'}
                            </span>
                        </span>
                    </div>

                    <div className="d-flex align-items-start justify-content-between">
                        <img src="/assets/img/doc2sign-logo.png" alt="Doc2sign" style={{ height: 32, width: 'auto' }} />

                        <div className="d-flex flex-column align-items-end">
                            <div className="mb-3 text-muted font-weight-bold">
                                <i className="far fa-user mr-2"></i>
                                {isLoggedIn ? `Cuenta: ${this.state.doc2signCredentials.email}` : 'Sin cuenta conectada'}
                            </div>

                            <button
                                type="button"
                                className={isLoggedIn ? 'btn font-weight-bolder' : 'btn btn-primary font-weight-bolder'}
                                style={isLoggedIn ? { background: '#FFFFFF', border: '1px solid #E4E6EF', color: '#8950FC' } : undefined}
                                onClick={() => isLoggedIn ? this.logoutDoc2Sign() : this.redirectToDoc2SignAuthWidget()}
                            >
                                {isLoggedIn && <i className="fa fa-unlink mr-2" style={{ fontSize: 12, color: '#B5B9C8' }}></i>}
                                {!isLoggedIn && <i className="fa fa-link mr-2" style={{ fontSize: 12 }}></i>}
                                {isLoggedIn ? 'Desconectarme' : 'Conectar'}
                            </button>
                        </div>
                    </div>

                    <div className="d-none">
                        <label className="align-items-start checkbox checkbox-outline mr-4">
                            <input
                                name="enabled"
                                type="checkbox"
                                ref={this.checkboxRef}
                                disabled={!isLoggedIn}
                                defaultChecked={this.state.enabled}
                                onClick={(e) => this.toggleDoc2SignFeature(e)}
                            />
                            <span className="w-25px h-25px rounded-0"></span>
                        </label>
                    </div>
                </div>
            </div>
        )
    }
}

export default AuthDoc2Sign;

if (document.getElementById('AuthDoc2Sign')) {
    ReactDOM.render(<AuthDoc2Sign/>, document.getElementById('AuthDoc2Sign'));
}
